import { useEffect, useState } from "react";
import { Button, ButtonSize, ButtonVariant } from "shared/components";
import { useSettingsController } from "../../controller";
import { SyncOption, SyncOptionLabels } from "../../constants";
import { SettingsCard } from "../SettingsCard";
import { SettingsItem } from "../SettingsItem";
import { SyncEditModal } from "./SyncEditModal";

export const AppfolioIntegration = () => {
  const { currentSettings, updateSettings } = useSettingsController();
  const [editMode, setEditMode] = useState(false);
  const [showEditSyncModal, setShowEditSyncModal] = useState(false);

  const [appfolioUsername, setAppfolioUsername] = useState("");
  const [appfolioPassword, setAppfolioPassword] = useState("");
  const [appfolioUrl, setAppfolioUrl] = useState("");
  const [syncOption, setSyncOption] = useState<SyncOption | string>(
    SyncOption.EVERY_SYNC
  );

  const settings = currentSettings.appfolio;

  useEffect(() => {
    setAppfolioUsername(settings.appfolioUsername || "");
    setAppfolioPassword(settings.appfolioPassword || "");
    setAppfolioUrl(settings.appfolioUrl || "");
    setSyncOption(settings.appfolioSync || SyncOption.EVERY_SYNC);
  }, [
    settings.appfolioUsername,
    settings.appfolioPassword,
    settings.appfolioUrl,
    settings.appfolioSync
  ]);

  const handleSaveSettings = () => {
    if (
      settings.appfolioUsername !== appfolioUsername ||
      settings.appfolioPassword !== appfolioPassword ||
      settings.appfolioUrl !== appfolioUrl
    )
      updateSettings({
        appfolioUsername,
        appfolioPassword,
        appfolioUrl
      });
  };

  return (
    <>
      <SettingsCard title="Appfolio integration" showButton={false}>
        <div className="border-b border-alpha-40 my-6" />
        <div className="flex mb-6 items-center justify-between">
          <h3 className="text-content-200 text-sm font-medium">
            Identity and access management
          </h3>
          {editMode ? (
            <Button
              variant={ButtonVariant.TEXT}
              size={ButtonSize.XS}
              onClick={() => {
                handleSaveSettings();
                setEditMode(false);
              }}
            >
              Save
            </Button>
          ) : (
            <Button
              variant={ButtonVariant.TEXT}
              size={ButtonSize.XS}
              onClick={() => setEditMode(true)}
            >
              Edit
            </Button>
          )}
        </div>
        <div className="mb-4">
          <SettingsItem
            title="Username"
            value={appfolioUsername}
            editMode={editMode}
            onChange={setAppfolioUsername}
          />
        </div>
        <div className="mb-4">
          <SettingsItem
            title="Password"
            value={appfolioPassword}
            editMode={editMode}
            onChange={setAppfolioPassword}
          />
        </div>
        <SettingsItem
          title="URL"
          value={appfolioUrl}
          editMode={editMode}
          onChange={setAppfolioUrl}
        />
        <div className="border-b border-alpha-40 my-6" />
        <div className="flex items-center justify-between mb-4">
          <p className="text-content-1000 text-sm font-medium">
            Sync AppFolio{" "}
            <span className="font-bold">
              &quot;Posted to your website&quot;
            </span>{" "}
            status with the ability to submit applications for the unit in Boom
          </p>
          <Button
            variant={ButtonVariant.TEXT}
            size={ButtonSize.XS}
            onClick={() => setShowEditSyncModal(true)}
          >
            Edit
          </Button>
        </div>
        <p className="text-content-500 font-medium text-sm">
          {SyncOptionLabels[settings.appfolioSync || SyncOption.EVERY_SYNC]}
        </p>
      </SettingsCard>
      <SyncEditModal
        opened={showEditSyncModal}
        onClose={() => setShowEditSyncModal(false)}
        setSyncOption={setSyncOption}
        syncOption={syncOption as SyncOption}
      />
    </>
  );
};
